/**
 * Hook `didOpen` do SweetAlert2.
 *
 * Marca o popup como não-traduzível para o Google Translate não reescrever o
 * conteúdo do modal. O caso mais visível é o glifo do ícone: o "i" do ícone
 * `info` era traduzido para "eu" no modal de "Sessão expirada"; o "!" do
 * `warning` e o "?" do `question` sofrem o mesmo problema.
 *
 * @param {HTMLElement} popup elemento raiz do popup entregue pelo SweetAlert2
 */
export default function protectSwalFromTranslate(popup) {
  if (!popup) return;
  popup.setAttribute("translate", "no");
  popup.classList.add("notranslate");
}
